import Image from 'core/image';
import PropTypes from 'prop-types';
import styles from 'styles/Coverage.module.scss';

const Item = ({ icon, description, isTitle = false }) => {
    if (isTitle) {
        return (
            <div>
                <Image src={icon} width={25} height={30} alt={description} />
                <p className={styles.title}>{description}</p>
            </div>
        );
    };

    return (
        <div>
            <Image src={icon} width={50} height={50} alt={description} />
            <p>{description}</p>
        </div>
    );
};

Item.propTypes = {
    icon: PropTypes.object.isRequired,
    description: PropTypes.string.isRequired,
    isTitle: PropTypes.bool
};

export default Item;
